var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.callForPrice)?_c('v-sheet',{staticClass:"px-2 text-caption my-1",attrs:{"rounded":"lg","outlined":""}},[_vm._v(" CALL FOR PRICE ")]):_c('div',{staticClass:"text-h6 font-weight-regular"},[_vm._v(" "+_vm._s(this.price)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }